import api from "../../api.service";
import Swal from "sweetalert2";
import router from '@/router';
import store from "../";

const state = {
    contactsCustomerList: [],
    storeOrderList: [],
    isRead: true,
    contactCustomerDto:  {
        id: 0,
        text: null,
        userInfoId: null,
        userFirstName: null,
        userLastName: null
    },
    orderDto: {
        id: 0,
        title: null, //  notifyTitle,
        description: null, // imagesNote, notifyDesc, 
        orderType: 0, // UploadImages = 1,UpdateInformation = 2,Notification = 3
        orderState: false,
        shopId: null,
        shopName: null,
        images: [], // images,
        smsDto: {}
    }
};

const getters = {
    contactsCustomerList(state) {
        return state.contactsCustomerList;
    },
    storeOrderList(state){
        return state.storeOrderList;
    },
    contactCustomerDto(state){
        return state.contactCustomerDto;
    },
    orderDto(state){
        return state.orderDto;
    },
    isRead(state){
        return state.isRead;
    }
};

const mutations = {
    GET_CONTACTS_CUSTOMER(state, payload) {
        state.contactsCustomerList = payload;
        store.dispatch('setLoading', false);
    },
    GET_ORDER_STORE(state, payload){
        state.storeOrderList = payload;
        store.dispatch('setLoading', false);
    },
    TRANSFER_TO_NOTIFICATION(state, payload){
       // state.storeOrderList.splice(payload, 1);
        Swal.fire({
            title: "تم الترحيل !",
            text: `تم ترحيل الطلب بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
    },
    ADD_IMAGES_SHOP(state , payload){
       // state.storeOrderList.splice(payload, 1);
        Swal.fire({
            title: "تم الترحيل !",
            text: `تم ترحيل الطلب بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
    },
    DELETE_CONTACT_CUSTOMER(state, payload){
        state.contactsCustomerList.splice(payload, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف الطلب بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
        router.push('/contact/customers');
    },
    DELETE_ORDER_STORE(state, payload){
        state.storeOrderList.splice(payload, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف الطلب بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
        router.push('/contact/store-order');
    },
    GET_CUSTOMER_DETAILS(state, payload){
        if(!state.contactsCustomerList.length) {
            const listinterval = setInterval(() => {
                if(state.contactsCustomerList.length){
                    Object.assign(state.contactCustomerDto, state.contactsCustomerList[payload]);
                    clearInterval(listinterval);
                }
            }, 500) 
        } else {
            Object.assign(state.contactCustomerDto, state.contactsCustomerList[payload]);
        }
    },
    GET_ORDER_DETAILS(state, payload){
        console.log(state.storeOrderList[payload])
        if(!state.storeOrderList.length) {
            const listinterval = setInterval(() => {
                if(state.storeOrderList.length){
                    Object.assign(state.orderDto, state.storeOrderList[payload]);
                    clearInterval(listinterval);
                }
               
            }, 500) 
        } else {
            Object.assign(state.orderDto, state.storeOrderList[payload]);
        }
    },
    SET_READ_ORDER(state, payload)
    {
        var index = state.storeOrderList.findIndex(item=> item.id == payload);
        state.storeOrderList[index].isRead = true;
    },
    SET_READ_CONTACT(state, payload)
    {
        var index = state.contactsCustomerList.findIndex(item=> item.id == payload);
        state.contactsCustomerList[index].isRead = true;
    },
    CHECK_IF_ORDER_READ(state, payload)
    {
        state.isRead = payload;
    },
    HANDLE_ORDER(state, payload) {
        state.orderDto.orderState = true;
        var index = state.storeOrderList.findIndex(item => item.id ==  state.orderDto.id);
        Object.assign(state.storeOrderList[index], state.orderDto);
        Object.assign(state.orderDto.smsDto, payload);
    }
};

const actions = {
    async fetchContactsCustomer(context) {
        store.dispatch('setLoading', true);
        const { data } = await api
            .query(`/api/Contact/GetContacts`)
            .then(data => data);
           
        context.commit("GET_CONTACTS_CUSTOMER", data);
    },
    async fetchOrdersStore(context) {
        store.dispatch('setLoading', true);
        const { data } = await api
            .query(`/api/Order/GetOrders`)
            .then(data => data);
           
        context.commit("GET_ORDER_STORE", data);
    }, 
    async CheckIfOrderRead(context) {
         const { data } = await api
            .query("/api/Order/CheckIfOrderRead")
            .then(data => data);
        context.commit("CHECK_IF_ORDER_READ", data);
    },
     async setReadOrder(context, payload) {
         await api
            .post(`/api/Order/SetReadOrder?orderId=${payload}`)
            .then(data => data);
        context.commit("SET_READ_ORDER", payload);
    },
    async setReadContact(context, payload) {
        
         await api
            .post(`/api/Contact/SetReadContact?contactId=${payload}`)
            .then(data => data);
        context.commit("SET_READ_CONTACT", payload);
    },
    async transferToNotification(context, payload){
        console.log(payload)
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success px-4",
                cancelButton: "btn btn-danger px-4",
            },
            buttonsStyling: true,
        });
        swalWithBootstrapButtons.fire({
            title: "هل أنت متأكد؟",
            text: "هل فعلاً تريد ترحيل الطلب ؟",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "نعم !",
            cancelButtonText: "إلغاء",
            reverseButtons: false,
        }) .then((result) => {
            if (result.value) {
                console.log(payload)
                api
                .post(`/api/Order/TransferToNotification` , { 
                    Id : payload.order.id,
                    Title : payload.order.title,
                    Description : payload.order.description,
                    ShopId : payload.order.shopId,
                    OrderType : 3
                })
                .then(data => {
                    context.commit('TRANSFER_TO_NOTIFICATION', payload.index);
                });
            }
        });
    },
    async addImagesShop(context, payload){
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success px-4",
                cancelButton: "btn btn-danger px-4",
            },
            buttonsStyling: true,
        });
        swalWithBootstrapButtons.fire({
            title: "هل أنت متأكد؟",
            text: "هل فعلاً تريد ترحيل الطلب ؟",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "نعم !",
            cancelButtonText: "إلغاء",
            reverseButtons: false,
        }) .then((result) => {
            console.log(result)
            if (result.value) {
                api
                .post(`/api/Order/AddImagesShop?id=${payload.id}`)
                    .then(data => {
                   
                        if (data.data == true)

                            context.commit('ADD_IMAGES_SHOP', payload.index);
                        else
                            context.commit("ERROR_MESSAGE", 'يرجة التأكد من وجود المتجر');
                });
            }
        });
    },
    async deleteContactsCustomer(context, payload) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success px-4",
                cancelButton: "btn btn-danger px-4",
            },
            buttonsStyling: true,
        });
        swalWithBootstrapButtons.fire({
            title: "هل أنت متأكد؟",
            text: "هل فعلاً تريد حذف الطلب ؟",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "نعم !",
            cancelButtonText: "إلغاء",
            reverseButtons: false,
        }) .then((result) => {
            if (result.value) {
                const { data } = api
                    .delete(`/api/Contact/RemoveContact?userId=${payload.id}`)
                    .then(data => data);
                context.commit("DELETE_CONTACT_CUSTOMER", payload.index);
            }
        });
    },
    async deleteOrdersStore(context, payload) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success px-4",
                cancelButton: "btn btn-danger px-4",
            },
            buttonsStyling: true,
        });
        swalWithBootstrapButtons.fire({
            title: "هل أنت متأكد؟",
            text: "هل فعلاً تريد حذف الطلب ؟",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "نعم !",
            cancelButtonText: "إلغاء",
            reverseButtons: false,
        }) .then((result) => {
            if (result.value) {
                const { data } = api
                    .delete(`/api/Order/RemoveOrder?id=${payload.id}`)
                    .then(data => data);
                context.commit("DELETE_ORDER_STORE", payload.index);
            }
        });
    },
    getCustomerDetails(context, index){
        context.commit('GET_CUSTOMER_DETAILS', index);
    },
    getOrderDetails(context, index){
        context.commit('GET_ORDER_DETAILS', index);
    },
    async handleOrder(context, payload){
        const { data } = await api.post("/api/Shop/SendShopSMS", payload)
            .then((data) => data);
        if (typeof data === 'string') {
            context.commit("ERROR_MESSAGE", data);
        } else {
            context.commit("SUCCESS_MSG");
            context.commit("HANDLE_ORDER", data);
        }
    }
};

const Contacts = {
    state,
    getters,
    actions,
    mutations
};
export default Contacts;
